import iconColor from 'components/iconColor'
import FasCircle from 'components/Legacy/Icons/FasCircle'
import Tooltip from 'components/Legacy/Tooltip'
import messages from 'lang'
import identity from 'lodash/identity'
import times from 'lodash/times'
import React from 'react'
import { injectIntl, WrappedComponentProps as _I } from 'react-intl'
import styled from 'styled-components'
import { px, zIndex } from 'utils'

import { PropsType } from '.'

const MAX_SCORE = 4

const CIRCLES = times<number>(MAX_SCORE, identity)

const COLORS = ['dark200', 'red700', 'royal', 'green600', 'green600'].map((code) => iconColor(code))

const getColor = (props: PropsType) => COLORS[props.score]

const GreyCircle = styled(FasCircle)`
  margin: 0 1px;
  ${iconColor('dark200')};
`

const ColorCircle = styled(FasCircle)`
  margin: 0 1px;
  ${getColor};
`

const Wrapper = styled.div`
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  z-index: ${zIndex(0)};

  > div {
    display: flex;
    flex-direction: row-reverse;
  }
`

class PasswordStrength extends React.Component<PropsType & _I> {
  renderCircles = () => {
    const { score } = this.props

    return CIRCLES.map((key) =>
      key >= score ? (
        <GreyCircle key={key} size={px(0.5)} />
      ) : (
        <ColorCircle key={key} score={score} size={px(0.5)} />
      )
    )
  }

  render() {
    const { intl, score } = this.props

    const STRENGTH = [
      intl.formatMessage(messages.weak),
      intl.formatMessage(messages.weak),
      intl.formatMessage(messages.okay),
      intl.formatMessage(messages.strong),
      intl.formatMessage(messages.very_strong)
    ]

    return (
      <Wrapper>
        <Tooltip renderTrigger={this.renderCircles}>
          {intl.formatMessage(messages.password_strength_tooltip, {
            strength: STRENGTH[score]
          })}
        </Tooltip>
      </Wrapper>
    )
  }
}
export default injectIntl(PasswordStrength)
